const hours = ['Full-time', 'Part-time', 'Flexible'];

export default hours;
